import { render, staticRenderFns } from "./HeaderGroup.vue?vue&type=template&id=60d00a5b&scoped=true&"
import script from "./HeaderGroup.vue?vue&type=script&lang=js&"
export * from "./HeaderGroup.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGroup.vue?vue&type=style&index=0&id=60d00a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d00a5b",
  null
  
)

export default component.exports